import React, { createContext, useContext, useState, useCallback } from 'react';

const SupportDashboardContext = createContext(null);

export const SupportDashboardProvider = ({ children }) => {
    const [actions, setActions] = useState(null);

    const registerActions = useCallback((next) => {
        setActions(next);
    }, []);

    const clearActions = useCallback(() => {
        setActions(null);
    }, []);

    return (
        <SupportDashboardContext.Provider value={{ actions, registerActions, clearActions }}>
            {children}
        </SupportDashboardContext.Provider>
    );
};

export const useSupportDashboard = () => useContext(SupportDashboardContext);